export default "__VITE_ASSET__VsODvgyl__"